import React from 'react'
import { Text } from 'blaze-ui/Text/Text'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import { SettingScreen } from 'components/Settings/types'
import { getPlatformDisplayName } from 'utils/platformDisplayNames'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'

type Props = {
  integration: ExternalIntegration
  onClose?: (options?: { openSettingScreen?: SettingScreen }) => void
  requiredFieldName?: string | null
}

export const AutopilotInfo = ({ integration }: Props): React.ReactElement => {
  const workspace = useCurrentWorkspace()
  const isAutopilot = workspace?.is_virtual_marketer
  const showAutopilotInfo = isAutopilot && workspace.is_virtual_marketer_onboarding_completed

  if (!showAutopilotInfo) {
    return <></>
  }

  const integrationName = getPlatformDisplayName(integration.provider)
  return (
    <Text>
      {`Blaze will automatically post all of your ${integrationName} content to your ${integration.name} account going forward. You can delete or unschedule posts on your calendar.`}
    </Text>
  )
}
